export const ADMIN_LOAD_COMPANIES_REQUEST = 'admin/LOAD_COMPANIES_REQUEST';
export const ADMIN_LOAD_COMPANIES_SUCCESS = 'admin/LOAD_COMPANIES_SUCCESS';
export const ADMIN_LOAD_COMPANIES_FAILURE = 'admin/LOAD_COMPANIES_FAILURE';

export const ADMIN_LOAD_COMPANY_REQUEST = 'admin/LOAD_COMPANY_REQUEST';
export const ADMIN_LOAD_COMPANY_SUCCESS = 'admin/LOAD_COMPANY_SUCCESS';
export const ADMIN_LOAD_COMPANY_FAILURE = 'admin/LOAD_COMPANY_FAILURE';

export const ADMIN_COMPANY_PAID_STATUS_REQUEST = 'admin/ADMIN_COMPANY_PAID_STATUS_REQUEST';
export const ADMIN_COMPANY_PAID_STATUS_FAILURE = 'admin/ADMIN_COMPANY_PAID_STATUS_FAILURE';

export const ADMIN_COMPANY_SUBSCRIPTION_REQUEST = 'admin/ADMIN_COMPANY_SUBSCRIPTION_REQUEST';
export const ADMIN_COMPANY_SUBSCRIPTION_FAILURE = 'admin/ADMIN_COMPANY_SUBSCRIPTION_FAILURE';

export const ADMIN_CREATE_COMPANY_REQUEST = 'admin/CREATE_COMPANY_REQUEST';
export const ADMIN_CREATE_COMPANY_SUCCESS = 'admin/CREATE_COMPANY_SUCCESS';
export const ADMIN_CREATE_COMPANY_FAILURE = 'admin/CREATE_COMPANY_FAILURE';

export const ADMIN_UPDATE_COMPANY_SETTINGS_REQUEST = 'admin/UPDATE_COMPANY_SETTINGS_REQUEST';
export const ADMIN_UPDATE_COMPANY_SETTINGS_SUCCESS = 'admin/UPDATE_COMPANY_SETTINGS_SUCCESS';
export const ADMIN_UPDATE_COMPANY_SETTINGS_FAILURE = 'admin/UPDATE_COMPANY_SETTINGS_FAILURE';

export const ADMIN_LOAD_PROPERTIES_REQUEST = 'admin/LOAD_PROPERTIES_REQUEST';
export const ADMIN_LOAD_PROPERTIES_SUCCESS = 'admin/LOAD_PROPERTIES_SUCCESS';
export const ADMIN_LOAD_PROPERTIES_FAILURE = 'admin/LOAD_PROPERTIES_FAILURE';

export const ADMIN_LOAD_RESERVATIONS_REQUEST = 'admin/LOAD_RESERVATIONS_REQUEST';
export const ADMIN_LOAD_RESERVATIONS_SUCCESS = 'admin/LOAD_RESERVATIONS_SUCCESS';
export const ADMIN_LOAD_RESERVATIONS_FAILURE = 'admin/LOAD_RESERVATIONS_FAILURE';

export const ADMIN_LOAD_PARTNERS_REQUEST = 'ADMIN_LOAD_PARTNERS_REQUEST';
export const ADMIN_LOAD_PARTNERS_SUCCESS = 'ADMIN_LOAD_PARTNERS_SUCCESS';
export const ADMIN_LOAD_PARTNERS_FAILURE = 'ADMIN_LOAD_PARTNERS_FAILURE';

export const ADMIN_LOAD_COMPANY_PROPERTIES_REQUEST = 'admin/LOAD_COMPANY_PROPERTIES_REQUEST';
export const ADMIN_LOAD_COMPANY_PROPERTIES_SUCCESS = 'admin/LOAD_COMPANY_PROPERTIES_SUCCESS';
export const ADMIN_LOAD_COMPANY_PROPERTIES_FAILURE = 'admin/LOAD_COMPANY_PROPERTIES_FAILURE';

export const ADMIN_UPDATE_COMPANY_PROPERTY_STATUS_REQUEST =
  'admin/UPDATE_COMPANY_PROPERTY_STATUS_REQUEST';
export const ADMIN_UPDATE_COMPANY_PROPERTY_STATUS_SUCCESS =
  'admin/UPDATE_COMPANY_PROPERTY_STATUS_SUCCESS';
export const ADMIN_UPDATE_COMPANY_PROPERTY_STATUS_FAILURE =
  'admin/UPDATE_COMPANY_PROPERTY_STATUS_FAILURE';
